export default class ForecastRuleGet {
  function: string;
  index: string | undefined;
  key: string;
  value: string;

  constructor(
    functionValue: string,
    key: string,
    value: string,
    index: string | undefined
  ) {
    this.function = functionValue;
    this.key = key;
    this.value = value;
    this.index = index;
  }
}
